export default "__VITE_ASSET__h08a57uw__"